<div class="image-container">
  <img [vcSrcset]="src" [alt]="attachment.originalFilename">
</div>

<div class="postfix" *ngIf="!hideRemove">
  <vc-link-button (click)="onRemoveClicked($event)">Remove</vc-link-button>
</div>
